import React from "react";
import { Formik, Form } from "formik";
import Model from "../../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../../Styles/InputStyles";

const CancelEviction = ({
    setIsCancelEviction,
    selectedData,
    cancelEvictionLoading,
    cancelEvictionMutate,
}) => {
    const handleCancelSubmit = () => {
        cancelEvictionMutate({ tenantId: selectedData?.data?.id || selectedData?.tenantId });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsCancelEviction}
            title="Eviction Cancellation Confirmation"
        >
            <WarningText>
                Please confirm if you wish to cancel the scheduled eviction process.
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsCancelEviction(false)}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleCancelSubmit}
                    disabled={cancelEvictionLoading}
                    className="bg-white border border-primary-color  text-primary-color hover:bg-primary-color hover:text-white"
                >
                    {cancelEvictionLoading ? "Processing..." : "Cancel Eviction"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default CancelEviction;
